import { NavItem } from "~/bff/types/NavItem";

export const getNavUrl = ({ url, urlSlug }: NavItem["props"] = {}) => {
  return url ?? urlSlug ?? undefined;
};
